"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.nullIfNotSet = void 0;
function nullIfNotSet(val) {
    if (val === 'NOT_SET')
        return null;
    return val;
}
exports.nullIfNotSet = nullIfNotSet;
